// Assistance Agreement Reducer

const assistanceAgreementReducerDefaultState = {
    savePersonalData: '0',
    implementAssistanceServices: '0',
    preventMemoryCharge: '0',
    beneficiaryName: "testif",
    beneficiaryFirstname: "",
    contractNumber: "",
    contractStartDate: "",
    beneficiaryAddress: "",
    beneficiaryZipCode: "",
    beneficiaryCity: "",
    authorizationDatetime: 0, 
    autorisationStockageDonnees: false
};

export default (state = assistanceAgreementReducerDefaultState, action) => {
    switch (action.type) {
        case 'SET_ASSISTANCE_AGREEMENT':
            return {
                ...state,
                beneficiaryName: action.data.name,
                contractStartDate: action.data.date,
                beneficiaryFirstname: action.data.firstName,
                beneficiaryAddress: action.data.address,
                beneficiaryZipCode: action.data.zipCode,
                beneficiaryCity: action.data.city,
                savePersonalData: action.data.savePersonalData,
                implementAssistanceServices: action.data.implementAssistanceServices,
                preventMemoryCharge: action.data.preventMemoryCharge,
                autorisationStockageDonnees: action.data.autorisationStockageDonnees
            };
        case 'GET_ASSISTANCE_AGREEMENT':
            return {
                ...state,
                beneficiaryName: action.data.beneficiaryName,
                contractStartDate: action.data.contractStartDate,
                beneficiaryFirstname: action.data.beneficiaryFirstname,
                beneficiaryAddress: action.data.beneficiaryAddress,
                beneficiaryAddressId: action.data.beneficiaryAddressId,
                beneficiaryZipCode: action.data.beneficiaryZipCode,
                beneficiaryCity: action.data.beneficiaryCity,
                savePersonalData: action.data.savePersonalData,
                implementAssistanceServices: action.data.implementAssistanceServices,
                preventMemoryCharge: action.data.preventMemoryCharge,
                autorisationStockageDonnees: action.data.autorisationStockageDonnees
            };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/assistanceAgreement.js